export default "__VITE_ASSET__BpKGngMM__"